import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';

const CATEGORY_COLOR = {
  'Underweight': 'info',
  'Normal weight': 'success',
  'Overweight': 'warning',
  'Obese': 'error',
};

/**
 * BMIResult - displays the calculated BMI value and a color-coded category chip.
 *
 * @param {Object} props
 * @param {number} props.bmi
 * @param {string} props.category
 * @param {boolean} props.visible
 */
function BMIResult({ bmi, category, visible }) {
  if (!visible) {
    return null;
  }

  return (
    <Card variant="outlined" sx={{ mt: 2 }} id="result">
      <CardContent>
        <Typography variant="h3" gutterBottom>Your Result</Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 1 }}>
          <Typography color="text.secondary">BMI:</Typography>
          <Typography variant="h2" component="span" id="bmiValue">
            {bmi !== null && bmi !== undefined ? bmi.toFixed(2) : '--'}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography color="text.secondary">Category:</Typography>
          <Chip
            id="bmiCategory"
            label={category || '--'}
            color={CATEGORY_COLOR[category] || 'default'}
            sx={{ fontWeight: 600 }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default BMIResult;
